import { createStyleSheet } from './style';
// 创建入口
export var createPortal = function () {
    var portal = document.createElement('div');
    var styleSheet = createStyleSheet();
    portal.appendChild(styleSheet);
    document.body.appendChild(portal);
    return portal;
};
// 创建底部banner
export var createBottomBanner = function () {
    // 外层
    var wrap = document.createElement('div');
    // 内层，固定1100px
    var inner = document.createElement('div');
    // 文案层，有最小高度和最大高度，超过最大高度可滚动
    var text = document.createElement('p');
    // 按钮容器
    var btns = document.createElement('div');
    // Cookie Setting按钮
    var setting = document.createElement('button');
    // Reject All按钮
    var reject = document.createElement('button');
    // Accept All按钮
    var accept = document.createElement('button');
    // 简单版本 learn more
    var learnMore = document.createElement('a');
    // 简单版本 OK
    var OK = document.createElement('button');
    // 简单版本 标题
    var simpleTit = document.createElement('p');
    // 设置样式
    wrap.className = 'cke_wp';
    inner.className = 'cke_in';
    text.className = 'cke_tx';
    btns.className = 'cke_bt';
    setting.className = 'cke_st';
    reject.className = 'cke_rj';
    accept.className = 'cke_ap';
    learnMore.className = 'cke_lm';
    OK.className = 'cke_ok';
    simpleTit.className = 'cke_stit';
    learnMore.setAttribute('target', '_blank');
    learnMore.setAttribute('rel', 'noopener noreferrer');
    // 设置文案
    setting.innerHTML = 'Cookie Setting';
    reject.innerHTML = 'Reject All';
    accept.innerHTML = 'Accept All';
    learnMore.innerHTML = 'Learn More';
    OK.innerHTML = 'OK';
    simpleTit.innerHTML = 'Cookies Banner';
    // 添加节点
    wrap.appendChild(inner);
    inner.appendChild(simpleTit);
    inner.appendChild(text);
    inner.appendChild(btns);
    btns.appendChild(setting);
    btns.appendChild(reject);
    btns.appendChild(accept);
    btns.appendChild(learnMore);
    btns.appendChild(OK);
    return {
        wrap: wrap,
        inner: inner,
        text: text,
        btns: btns,
        setting: setting,
        reject: reject,
        accept: accept,
        simpleTit: simpleTit,
        learnMore: learnMore,
        OK: OK
    };
};
// 创建侧边banner
export var createSideBanner = function () {
    // 外层
    var wrap = document.createElement('div');
    wrap.className = 'cke_side cke_side_hd';
    // top顶部
    var cke_top = document.createElement('div');
    cke_top.className = 'cke_top';
    var cke_top_span = document.createElement('span');
    cke_top_span.innerHTML = 'Cookie Setting';
    var close = document.createElement('span');
    close.className = 'cke_side_close';
    // 添加top顶部
    cke_top.appendChild(cke_top_span);
    cke_top.appendChild(close);
    wrap.appendChild(cke_top);
    // 内容区域
    var content = document.createElement('div');
    content.className = 'cke_ctn';
    // 描述
    var description = document.createElement('p');
    description.className = 'cke_top_desc';
    // 添加content
    content.appendChild(description);
    wrap.appendChild(content);
    // 保存按钮
    var save = document.createElement('button');
    save.className = 'side_save';
    save.innerHTML = 'Save';
    // 添加保存按钮
    wrap.appendChild(save);
    return {
        wrap: wrap,
        close: close,
        content: content,
        description: description,
        save: save
    };
};
// 生成侧边栏每个政策的dom结构
export var createCookiePart = function (options, switchTrigger) {
    // box外层
    var box = document.createElement('div');
    box.className = 'cke_box';
    var cke_box_t = document.createElement('div');
    cke_box_t.className = 'cke_box_t';
    // 名称
    var name = document.createElement('span');
    name.className = 'cke_box_n';
    name.innerHTML = options.name;
    // 描述
    var desc = document.createElement('p');
    desc.className = 'cke_box_desc';
    desc.innerHTML = options.description;
    // 添加固定内容
    box.appendChild(cke_box_t);
    cke_box_t.appendChild(name);
    box.appendChild(desc);
    // 如果没有cookie详细信息，直接返回
    if (!options.cookies || options.cookies.length === 0) {
        return {
            box: box,
            name: name,
            desc: desc
        };
    }
    // 有则生成详细信息
    var cookies = options.cookies;
    // 详细信息外层
    var cookieDetailWrap = document.createElement('div');
    cookieDetailWrap.className = 'cke_detail';
    // 详细信息tip
    var cookieTip = document.createElement('p');
    cookieTip.className = 'cke_detail_t';
    cookieTip.innerHTML = 'Cookie details';
    cookieTip.dataset.status = 'on';
    // 三角形
    var shape = document.createElement('span');
    shape.className = 'cke_dl_o'; //默认开启 cke_dl_c 隐藏
    cookieTip.appendChild(shape);
    var details = document.createElement('div');
    // details.style.display = 'none'; // 默认隐藏
    // 整合
    cookieDetailWrap.appendChild(cookieTip);
    cookieDetailWrap.appendChild(details);
    var _loop_1 = function (i) {
        var item = cookies[i];
        var link = document.createElement('div');
        link.className = 'cke_detail_list';
        var line1 = document.createElement('div');
        line1.className = 'cke_detail_le';
        // 名称
        var line1span1 = void 0;
        if (!item.link) {
            line1span1 = document.createElement('span');
        }
        else {
            line1span1 = document.createElement('a');
            line1span1.setAttribute('href', item.link);
            line1span1.setAttribute('target', "_blank");
            line1span1.setAttribute('rel', "noopener noreferrer");
        }
        line1span1.innerHTML = item.name + '(' + item.provider + ')';
        // 开关
        var boxswitch = document.createElement('div');
        var cke_swc_span = document.createElement('span');
        // 设置标识
        boxswitch.dataset.key = item.key;
        boxswitch.appendChild(cke_swc_span);
        line1.appendChild(line1span1);
        line1.appendChild(boxswitch);
        // 是否可用
        if (!item.enable) {
            boxswitch.className = 'cke_swc cke_swc_c';
            boxswitch.dataset.status = 'off';
        }
        else {
            boxswitch.className = 'cke_swc cke_swc_o';
            boxswitch.dataset.status = 'on';
        }
        // 是否禁用
        if (!item.allowChange) {
            boxswitch.className += ' cke_swc_disabled';
            boxswitch.dataset.status = 'disabled';
        }
        // 添加开关事件
        boxswitch.addEventListener('click', function () {
            var switchStatus = boxswitch.dataset.status;
            // let switchType = boxswitch.dataset.type;
            // let switchName = boxswitch.dataset.name;
            var key = boxswitch.dataset.key;
            if (switchStatus === 'disabled') {
                return;
            }
            if (switchStatus === 'on') {
                // 关闭
                boxswitch.className = 'cke_swc cke_swc_c';
                boxswitch.dataset.status = 'off';
                switchTrigger({ key: key }, false);
            }
            else {
                // 打开
                boxswitch.className = 'cke_swc cke_swc_o';
                boxswitch.dataset.status = 'on';
                switchTrigger({ key: key }, true);
            }
        });
        // 整合
        link.appendChild(line1);
        details.appendChild(link);
    };
    // 添加详细cookie数据
    for (var i = 0; i < cookies.length; i++) {
        _loop_1(i);
    }
    // 加载事件，点击隐藏、显示
    cookieTip.addEventListener('click', function () {
        var openStatus = cookieTip.dataset.status;
        if (openStatus === 'off') {
            // 打开
            cookieTip.dataset.status = 'on';
            details.style.display = 'block';
            shape.className = 'cke_dl_o';
        }
        else {
            // 关闭
            cookieTip.dataset.status = 'off';
            details.style.display = 'none';
            shape.className = 'cke_dl_c';
        }
    });
    // 添加到box容器
    box.appendChild(cookieDetailWrap);
    return {
        box: box,
        name: name,
        desc: desc
    };
};
//# sourceMappingURL=createDom.js.map